export enum EVariant {
  COLOR = 'COLOR',
  SIZE = 'SIZE',
}
